import { render, staticRenderFns } from "./OrganisationsForm.vue?vue&type=template&id=529f47e6&scoped=true&"
import script from "./OrganisationsForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationsForm.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationsForm.vue?vue&type=style&index=0&id=529f47e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f47e6",
  null
  
)

export default component.exports